import $ from 'jquery/src/jquery';

export default () => {
    const nodeSelectors = {
        container: '[js-navigation="container"]',
        hamburger: '[js-navigation="hamburger"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        initNav()
    }

    function initNav() {
        $(nodeSelectors.hamburger).on('click', function () {
            $(this).toggleClass('active')
            let body = $("html, body");
            // body.stop().animate({scrollTop:0}, 100, 'swing');
            body.toggleClass('no-scroll')
            $(nodeSelectors.container).fadeToggle()
        })

        $(nodeSelectors.container + ' .menu-item-has-children').on('click', function (e) {
            $(this).toggleClass('active')
            $(this).find(' > .sub-menu').slideToggle()
        })

        // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
        let vh = window.innerHeight * 0.01;
        // Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty('--vh', `${vh}px`);

        // We listen to the resize event
        window.addEventListener('resize', () => {
            // We execute the same script as before
        let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        });
    }

    return Object.freeze({
        init,
    })
}